import AdditionalField from "./AdditionalField";
import Icon from "components/shared/Icon";
import Button from "components/shared/Button";

const AdditionalFields = (props) => {
	const {
		validateForm,
		additionalFields,
		formInputs,
		formGroups,
		conditionalsFields,
		multipleAttractionsForms,
		index,
		setMultipleAttractionsForms,
		parentClass,
		removeText,
		...rest
	} = props;

	const mainClass = "help-additional-fields";

	return (
		<div className={mainClass}>
			{additionalFields.title && (
				<div className={`${mainClass}__title`}>
					{additionalFields.title}{" "}
					{multipleAttractionsForms > 0 &&
						multipleAttractionsForms === index && (
							<Button
								className={`${parentClass}__button ${parentClass}__button--secondary ${parentClass}__button--outline`}
								title={removeText}
								childrenPosition={0}
								secondary
								onClick={() => {
									setMultipleAttractionsForms(multipleAttractionsForms - 1);
									validateForm();
								}}
							>
								<Icon
									className="help-icon--close-button--outline"
									icon="close-button"
								></Icon>
							</Button>
						)}
				</div>
			)}
			<div className={`${mainClass}__body`}>
				{additionalFields?.fields?.map((field, index) => {
					if (Array.isArray(field?.formFields) && field.formFields.length) {
						return (
							<div key={index} className={`${mainClass}__container`}>
								{field?.title && (
									<label className={`${mainClass}__label`}>{field.title}</label>
								)}
								<div className={`${mainClass}__group`}>
									{field.formFields.map((groupField, fieldIndex) => (
										<AdditionalField
											key={`${field.id}-${fieldIndex}`}
											{...groupField}
											{...rest}
											value={formInputs[groupField?.name]}
										/>
									))}
								</div>
							</div>
						);
					} else {
						return (
							<div className={`${mainClass}__field`} key={index}>
								<AdditionalField
									key={index}
									{...field}
									{...rest}
									value={formInputs[field?.name]}
								/>
								{conditionalsFields &&
									conditionalsFields?.map(
										(conditionalsfield, conditionalsIndex) => {
											return conditionalsfield?.parent === field?.name ? (
												<AdditionalField
													key={index + conditionalsIndex}
													{...conditionalsfield}
													{...rest}
													value={formInputs[conditionalsfield?.name]}
												/>
											) : null;
										}
									)}
							</div>
						);
					}
				})}
			</div>
		</div>
	);
};

export default AdditionalFields;
